// @mui
import { Stack, Typography, Button } from '@mui/material';
// hooks
import { useAuth0 } from '@auth0/auth0-react';
// layouts
import LoginLayout from '../../layouts/login';

// ----------------------------------------------------------------------

export default function LoginAuth0() {
  // const { method } = useAuthContext();

  const { loginWithRedirect: login } = useAuth0();

  const handleLoginAuth0 = async () => {
    try {
      await login();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Sign in to Numinar</Typography>
      </Stack>

      <Button
        fullWidth
        color="inherit"
        size="large"
        variant="contained"
        onClick={handleLoginAuth0}
        sx={{
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          '&:hover': {
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          },
        }}
      >
        Login
      </Button>
    </LoginLayout>
  );
}
